import { render, staticRenderFns } from "./gtr-timer.vue?vue&type=template&id=24559415&scoped=true&"
import script from "./gtr-timer.vue?vue&type=script&lang=ts&"
export * from "./gtr-timer.vue?vue&type=script&lang=ts&"
import style0 from "./gtr-timer.vue?vue&type=style&index=0&id=24559415&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24559415",
  null
  
)

export default component.exports